// Mock data for portfolio

export const personalInfo = {
  name: "Rashad Garayev",
  tagline: "Frontend Developer | Backend Enthusiast",
  shortIntro:
    "Passionate about building scalable, modern web applications with cutting-edge technologies. Specialized in microfrontend architecture and creating seamless user experiences.",
  email: "reshadqarayev00@gmail.com",
  phone: "+994 XX XXX XX XX",
  location: "Baku",
  github: "https://github.com/rashadqarayev",
  linkedin: "https://linkedin.com/in/rashadgarayev",
  twitter: "https://x.com/rashadqryv",
};

export const technologies = [
  { name: "React", icon: "⚛️" },
  { name: "TypeScript", icon: "📘" },
  { name: "Node.js", icon: "🟢" },
  { name: "Webpack", icon: "📦" },
  { name: "MongoDB", icon: "🍃" },
  { name: "Docker", icon: "🐳" },
  { name: "AWS", icon: "☁️" },
  { name: "GraphQL", icon: "◆" },
];

export const projects = [
  {
    id: 1,
    title: "Netflix Clone",
    description:
      "A fully functional Netflix clone with user authentication, video streaming, and personalized recommendations. Built with React, Node.js, and MongoDB.",
    image:
      "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=800&h=400&fit=crop",
    tech: ["React", "TypeScript", "Node.js", "MongoDB"],
    route: "/netflix",
    featured: true,
    status: "Live",
  },
  {
    id: 2,
    title: "Spotify Clone",
    description:
      "Music streaming application with real-time playback, playlist management, and social features. Implements advanced audio controls and recommendations.",
    image:
      "https://images.unsplash.com/photo-1614680376593-902f74cf0d41?w=800&h=400&fit=crop",
    tech: ["React", "TypeScript", "Web Audio API", "Express"],
    route: "/spotify",
    featured: true,
    status: "Live",
  },
  {
    id: 3,
    title: "E-Commerce Platform",
    description:
      "Scalable e-commerce solution with payment integration, inventory management, and analytics dashboard.",
    image:
      "https://images.unsplash.com/photo-1557821552-17105176677c?w=800&h=400&fit=crop",
    tech: ["React", "Redux", "Stripe", "PostgreSQL"],
    route: "/ecommerce",
    featured: false,
    status: "In Development",
  },
];

export const experience = [
  {
    id: 1,
    company: "PASHA Bank OJSC",
    role: "Junior Frontend Developer",
    duration: "Oct 2024 - Present",
    description:
      "Developing secure banking applications and digital payment solutions. Implementing modern frontend architectures with strict security protocols and ensuring compliance with banking regulations.",
    technologies: ["React", "TypeScript", "Next.js", "Webpack"],
  },
  {
    id: 2,
    company: "Freelance",
    role: "Frontend Developer",
    duration: "Jun 2022 - Sep 2024",
    description:
      "Collaborated with diverse clients to deliver custom web solutions and e-commerce platforms. Built responsive applications using modern JavaScript frameworks, integrated third-party APIs, and optimized performance for better user experience.",
    technologies: [
      "React",
      "JavaScript",
      "TypeScript",
      "Tailwind CSS",
      "Firebase",
    ],
  },
];

export const education = [
  {
    id: 1,
    institution: "UNEC - Azerbaijan State University of Economics",
    degree: "Intelligent Systems Master's Program",
    duration: "2025 - Present",
    description:
      "Specialized in distributed systems and web technologies.",
  },
  {
    id: 2,
    institution: "Khazar University",
    degree: "Bachelor of Science in Computer Engineering",
    duration: "2021 - 2025",
    description:
      "Focus on software engineering and algorithms. Completed various projects in web development and data structures.",
  },
];

export const skills = {
  frontend: ["React", "TypeScript", "Next.js", "Vue.js", "Angular.js"],
  backend: ["Node.js", "Express", "GraphQL"],
  database: ["MongoDB", "PostgreSQL", "Firebase"],
  devops: ["Docker", "Kubernetes"],
  tools: ["Git", "Webpack", "Vite", "Jest", "Figma"],
};
